














































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
 
import RegularInspections from '../regularinspections/regularinspections.vue';
let ispartysrc= require("@/images/danghui.png");

class PageBHUserRequest extends PageRequest {
  Keyword: string;
  corporatetype: number; //nullable
  status: number;
   
}

 @Component({
        components:{RegularInspections}
    })
export default class Enterprisenformation extends AbpBase {
  rg() {
    this.rgModalShow = true;
  }
  //filters
  pagerequest: PageBHUserRequest = new PageBHUserRequest();
   
  
  rgModalShow: boolean = false;
  
  get list() {
                   
    return this.$store.state.enterpriseinformation.list;
  }
  get loading() {
    return this.$store.state.enterpriseinformation.loading;
  }
  

  pageChange(page: number) {
    this.$store.commit("enterpriseinformation/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("enterpriseinformation/setPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
    //this.pagerequest.corporatetype=1;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "enterpriseinformation/getAll",
      data: this.pagerequest,
    });
  }
     
  get pageSize() {
    return this.$store.state.enterpriseinformation.pageSize;
  }
  get totalCount() {
    return this.$store.state.enterpriseinformation.totalCount;
  }
  get currentPage() {
    return this.$store.state.enterpriseinformation.currentPage;
  }
  get corporatetypelist(){

    return this.$store.state.enterpriseinformation.corporatetypelist;
  }
   
 
  columns = [
    
     {
      
      title: this.L("单位名称"),
      key: "corporatename",
      
    },
      
    
     {
      
      title: this.L("联系人"),
      key: "contacts",
      width: 100, 
    },
     {
      
      title: this.L("联系电话"),
      key: "phone",
      width: 150, 
    },
   
    {
    
      title: this.L("是否启用"),
       width: 100,
      render: (h: any, params: any) => {
        return h("span", params.row.status==true ? this.L("Yes"): this.L("No") );
      },
    },
    
     
     
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 100,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                 // alert(params.row.id)
                 //
                 // this.$store.commit("regularinspections/riefid", params.row.id );
                 window.sessionStorage.setItem("regularinspections_riefid",params.row.id )
                  this.rg();
                },
              },
            },
             this.L("巡查记录")
          ),
          
        ]);
      },
    },
  ];
  async created() {
    //产废企业
    this.pagerequest.status=2;
    this.pagerequest.corporatetype=2;
    this.getCitys();
 
    this.getpage();
  }

  corporatetypeTxt(corporatetype){
          var txt="";
          var lst=this.corporatetypelist; 
          lst.forEach(item=>{
          
            if(item.id==corporatetype){
              txt=item.name;
            }             
         })
      return txt;
  }

  async  getCitys() {
   
     
     await this.$store.dispatch({
      type: "enterpriseinformation/getCitys",
    });
  }

  async getregularinspectionsAll(){

      await this.$store.dispatch({
      type: "enterpriseinformation/getregularinspectionsAll",
    });
  }

 //导出
   async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "enterpriseinformation/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				
					lt.map((item) => { // 这里修改要下载的字段内容

					  item.status == false ? item.status = '否' : item.status == true ?  item.status ='是' : item.status ='否';
            item.iswater == false ? item.iswater = '否' : item.iswater == true ?  item.iswater ='是' : item.iswater ='否';
            item.regulation == false ? item.regulation = '无' : item.regulation == true ?  item.regulation ='有' : item.regulation ='无';
            
            item.corporatetype=this.corporatetypeTxt(item.corporatetype);
            var industrycategory="";
            this.$store.state.enterpriseinformation.industrycategorylst.forEach(ids=>{
                     if(item.industrycategoryid==ids.id){
                        industrycategory=ids.name;

                     }

            })

            item.industrycategory=industrycategory;
					  return item;
           //corporatetype

					});

                 
    
					const filterVal = ['id', 'corporatename','corporatetype','corporateen','shorterform','province','region','county','village','address','zipcode','website','latitude','longitude','illustrate','unifiedcreditcode','businesslicense','legalrepresentative','bank','bankaccount','industrycategory','environmentalprotection','franchiselicense','cepnumber','environmentalprotectionmanager','scaleofwasteproduction','iswater','regulation','transportcertificateumber','contacts','phone','telephone','email','facsimile','platformregistrationid',
 'status'];// 取出要下载的表头字段
				 	const tHeader = ['ID','公司名称','单位类型','英文编码','简称','省份','区市','县区','乡镇/园区','通讯地址','邮政编码','网址','纬度','经度','说明','统一信用代码','营业执照','法定代表人','开户','帐号','行业类别','所属环保机构','特许经营许可证','环评编号','环保负责人','产废规模','是否靠近水源','规章制度（有/无）','道路运输证号','联系人','联系电话','固定电话','电子邮箱','传真','省级平台注册ID','是否启用'];// 把表头字段定义成想要的中文或英文
					const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '产废企业');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}

			
}
